import { Vue, Component, Prop } from 'vue-property-decorator';
// import FieldRender from '@/components/learing-registry/field-render/field-render';
import CommonUploadFile from '@/components/cards/common-upload-file/common-upload-file';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { adminUtilsAPI } from '@/providers/apis/admin-utils/admin-utils';
import { isAPICatchError } from '@/utils/utils';

@Component({
    name: 'create-tenant',
    components: {
        'common-upload-file': CommonUploadFile,
    },
})

export default class CreateTenant extends Vue {

    @Prop({ default: {} })
    private userData: any;

    private isUploading: boolean = false;

    private isSubmitted: boolean = false;

    private offset: number = 0;

    private limit: number = 40;

    private tenantDataCount: number = 0;

    private tenantList: any = [];

    private selectedTenant: any = {
        name: 'Select tenant',
        id: '',
    };

    private tenantDetailsForm: any = {
        tenant_name: {
            name: 'Name',
            field: 'b-form-input',
            modelKey: 'tenant_name',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        thumbnail: {
            name: 'Logo',
            field: 'b-form-file',
            modelKey: 'thumbnail',
            isFileUpload: true,
            modelValue: [],
            placeholder: 'Choose file',
            eventBind: { change: this.onUpdateFile.bind(this) },
        },
        shortName: {
            name: 'Short name',
            field: 'b-form-input',
            modelKey: 'shortName',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        tenant_parent_id: {
            name: 'Parent tenant',
            field: 'b-form-select',
            modelKey: 'tenant_parent_id',
            modelValue: '',
            propBind: {
                'options': [],
                'text-field': 'name',
                'value-field': 'id',
            },
            eventBind: {},
        },
        country: {
            name: 'Country',
            field: 'b-form-select',
            modelKey: 'country',
            modelValue: '',
            validate: { required: true },
            propBind: {
                'options': [],
                'text-field': 'name',
                'value-field': 'id',
            },
            eventBind: { change: this.onSelectCountry },
        },
        state: {
            name: 'State',
            field: 'b-form-select',
            modelKey: 'state',
            modelValue: '',
            propBind: {
                'options': [],
                'text-field': 'name',
                'value-field': 'id',
            },
            eventBind: {},
        },
    };

    private contactDetails: any = {
        contactName: {
            name: 'IT Contant Name',
            field: 'b-form-input',
            modelKey: 'contactName',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        contactEmail: {
            name: 'IT Contant Email',
            field: 'b-form-input',
            modelKey: 'contactEmail',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        contactNumber: {
            name: 'IT Contant No',
            field: 'b-form-input',
            modelKey: 'contactNumber',
            modelValue: '',
            validate: { required: true },
            propBind: {
                type: 'number',
            },
            eventBind: {},
        },
    };

    private get filteredTenantList() {
        return this.tenantList;
        // return this.tenantList.filter((item: any) => {
        //     return item;
        // });
    }

    private get imageURL() {
        const fieldObj = this.tenantDetailsForm.thumbnail;
        let modelValue = this.tenantDetailsForm.thumbnail.modelValue;
        if (fieldObj.isFileUpload && modelValue instanceof File) {
            modelValue = URL.createObjectURL(modelValue);
        }
        return modelValue;
    }

    private tenantDetails: any = {};

    private async mounted() {
        const params: any = {
            offset: 0,
            limit: this.limit,
        };
        await this.getTenantList(params);
        await this.fetchCountries();
        this.$nextTick().then(() => {
            this.scrollEventAttach();
        });
        this.tenantDetails = this.userData.createTenant;
    }

    // private mounted() {
    //     this.$nextTick().then(() => {
    //         this.scrollEventAttach();
    //     });
    // }

    private onBackTolist(key: any) {
        this.$emit('onBackParent', key);
    }

    private goNext(key: any) {
        this.isSubmitted = true;
        this.$validator.validate().then((valid) => {
            this.userData.createTenant = this.tenantDetails;
            this.$emit('onChangeComponent', key);
        });
    }

    private inputValidator(errors: any, keyName: string) {
        return this.isSubmitted && errors.has(keyName);
    }

    private onUpdateFile() {
        this.isUploading = true;
        setTimeout(() => {
            if (this.isUploading && this.tenantDetails.thumbnail instanceof File) {
                this.tenantDetailsForm.thumbnail.modelValue = URL.createObjectURL(this.tenantDetails.thumbnail);
                setTimeout(() => {
                    this.isUploading = false;
                }, 20);
            }
        }, 20);
    }

    private onSelectCountry(countryId: number) {
        this.fetchStates(countryId);
    }

    private fetchCountries() {
        taxonomyAPI.fetchTaxonomyCountry().then((countries: any) => {
            this.tenantDetailsForm.country.propBind.options = countries.groups;
        });
    }

    private fetchStates(countryId: number) {
        const params = {
            id: countryId,
        };
        taxonomyAPI.fetchTaxonomyState(params).then((states: any) => {
            this.tenantDetailsForm.state.propBind.options = states.groups;
        });
    }

    private async getTenantList(params: any) {
        if (this.tenantList.length !== 0 && this.offset >= this.tenantDataCount) {
            return;
        }
        const tenantData = await adminUtilsAPI.fetchTenantList(params);
        if (!isAPICatchError(tenantData)) {
            this.tenantList = this.tenantList.concat(tenantData.list);
            this.tenantDetailsForm.tenant_parent_id.propBind.options =
            this.tenantDetailsForm.tenant_parent_id.propBind.options.concat(tenantData.list);
            this.tenantDataCount = tenantData.total_count;
        } else {
            this.tenantList = [];
            this.tenantDetailsForm.tenant_parent_id.propBind.options = [];
        }
    }

    private async onScroll() {
        this.offset += this.limit;
        const params: any = {
            offset: this.offset,
            limit: this.limit,
        };
        await this.getTenantList(params);
    }

    private scrollEventAttach() {
        const tenantDd: any = document.querySelector('#tenant_parent_id .dropdown-menu');
        if (tenantDd) {
            tenantDd.addEventListener('scroll', (event: any) => {
                const { scrollHeight, scrollTop, clientHeight } = event.target;
                if (Math.abs(scrollHeight - clientHeight - scrollTop) < 1) {
                    this.onScroll();
                }
            });
        }
    }

    private selectTenantItem(item: any) {
        this.selectedTenant = item;
        this.tenantDetails.tenant_parent_id = item.id;
    }

}
